import { useEffect, useState } from "react";
import { getBlog } from "../lib/api";
import { motion } from "framer-motion";
import { Clock, User } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { getBlog().then(setPosts); }, []);

  return (
    <div data-testid="page-blog">
      <section className="pt-16 pb-16">
        <div className="container-page">
          <div className="eyebrow mb-4">Journal</div>
          <h1 className="text-5xl md:text-6xl leading-tight max-w-3xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Writings on the healing arts
          </h1>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-page">
          {posts[0] && (
            <motion.a href="#" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="block group mb-16" data-testid={`blog-featured`}>
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="aspect-[4/3] rounded-3xl overflow-hidden">
                  <img src={posts[0].image} alt={posts[0].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div>
                  <div className="text-xs tracking-widest uppercase text-[#D4AF37] mb-3">Featured · {posts[0].category}</div>
                  <h2 className="text-3xl md:text-5xl mb-4 group-hover:text-[#0EA5E9] transition" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{posts[0].title}</h2>
                  <p className="text-[#475569] text-lg leading-relaxed mb-6">{posts[0].excerpt}</p>
                  <div className="flex gap-6 text-sm text-[#475569]">
                    <span className="flex items-center gap-2"><User size={14} />{posts[0].author}</span>
                    <span className="flex items-center gap-2"><Clock size={14} />{posts[0].read_time}</span>
                  </div>
                </div>
              </div>
            </motion.a>
          )}

          <div className="grid md:grid-cols-2 gap-8">
            {posts.slice(1).map((p) => (
              <a key={p.id} href="#" className="group block rounded-3xl overflow-hidden border border-slate-100 hover:shadow-xl transition-shadow bg-white" data-testid={`blog-${p.id}`}>
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-8">
                  <div className="text-xs tracking-widest uppercase text-[#D4AF37] mb-3">{p.category}</div>
                  <h3 className="text-2xl mb-3 group-hover:text-[#0EA5E9] transition" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{p.title}</h3>
                  <p className="text-sm text-[#475569] leading-relaxed mb-4">{p.excerpt}</p>
                  <div className="flex gap-4 text-xs text-[#475569]">
                    <span>{p.date}</span>·<span>{p.read_time}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
